import { useEffect, useState } from 'react';

export default function HeroSection() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/edited_7020e5e574e7b7e5350c82819d463cbc_126a3369.jpg"
          alt="Luxury cosmetics background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/65 via-black/40 to-black/30" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/40" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-10 flex flex-col lg:flex-row items-center">
        <div className="lg:max-w-2xl text-center lg:text-left">
          <p
            className={`font-display italic text-[#7FCECC] text-lg mb-4 transition-all duration-700 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
            style={{ transitionDelay: '0.1s' }}
          >
            A Arte da Cosméticos Autêntica
          </p>
          <h1
            className={`font-display text-5xl lg:text-7xl text-white font-bold leading-tight mb-6 transition-all duration-700 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
            style={{ transitionDelay: '0.25s' }}
          >
            Tecnologia e{' '}
            <span className="italic text-[#7FCECC]">Cosméticos</span>
            <br />
            de forma acessível
          </h1>
          <p
            className={`text-white/80 text-lg lg:text-xl leading-relaxed mb-10 max-w-xl mx-auto lg:mx-0 transition-all duration-700 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
            style={{ transitionDelay: '0.4s' }}
          >
            Cosméticos premium formulados com ingredientes naturais selecionados. Ciência e natureza em perfeita harmonia para realçar sua beleza única de forma acessível.
          </p>

          <div
            className={`flex flex-col sm:flex-row gap-4 justify-center lg:justify-start transition-all duration-700 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
            style={{ transitionDelay: '0.55s' }}
          >
            <button
              onClick={() => scrollTo('produtos')}
              className="bg-[#0F7C7A] hover:bg-[#0A5F5C] text-white font-semibold px-10 py-4 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap text-base"
            >
              Explorar Produtos
            </button>
            <button
              onClick={() => scrollTo('sobre')}
              className="border border-white/60 hover:border-white text-white hover:bg-white/10 font-semibold px-10 py-4 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap text-base"
            >
              Conheça a Marca
            </button>
          </div>

          {/* Stats */}
          <div
            className={`flex gap-10 mt-14 justify-center lg:justify-start transition-all duration-700 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
            style={{ transitionDelay: '0.7s' }}
          >
            {[
              { value: '500K+', label: 'Clientes' },
              { value: '200+', label: 'Produtos' },
              { value: '12+', label: 'Anos' },
            ].map((stat) => (
              <div key={stat.label} className="text-center lg:text-left">
                <div className="font-display text-3xl font-bold text-[#7FCECC]">{stat.value}</div>
                <div className="text-white/70 text-sm mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/60 animate-bounce">
        <span className="text-xs tracking-widest uppercase">Scroll</span>
        <i className="ri-arrow-down-line text-lg" />
      </div>
    </section>
  );
}
